import { render, staticRenderFns } from "./SpecialInstagram.vue?vue&type=template&id=c89c46cc&scoped=true"
import script from "./SpecialInstagram.vue?vue&type=script&lang=ts"
export * from "./SpecialInstagram.vue?vue&type=script&lang=ts"
import style0 from "./SpecialInstagram.vue?vue&type=style&index=0&id=c89c46cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c46cc",
  null
  
)

export default component.exports